const CovarianceType = {
  HIST: {
    label: "HIST",
    value: "HIST",
  },
  SHORT: {
    label: "REGIME",
    value: "SHORT",
  },
  STATIC: {
    label: "STATIC",
    value: "CONST",
  },
};

export default CovarianceType;
